<template>
    <Sheet :v-loading="loading.global">
        <el-divider>
            <span style="font-size:1.1rem;padding-right: 10px;">
               學生基本資料查詢
            </span>
        </el-divider>
        <el-button
                @click="showFilter = !showFilter"
                :icon="showFilter ? 'el-icon-remove-outline': 'el-icon-circle-plus-outline'"
                size="mini"
                type="info"
                style="margin-bottom: 2px;"
        >
            過濾器
        </el-button>
        <el-collapse-transition>
            <el-card
                    shadow="never"
                    style="margin: 2px 0;"
                    v-if="showFilter"
            >
                <el-form :model="filter" label-width="120px">
                    <el-row>
                        <el-col :xl="4">
                            <el-form-item label="學號">
                                <el-input
                                        placeholder="請輸入學號"
                                        v-model="filter.studentId"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :xl="4">
                            <el-form-item label="姓名">
                                <el-input
                                        placeholder="請輸入姓名"
                                        v-model="filter.studentName"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :xl="4">
                            <el-form-item label="身分證字號">
                                <el-input
                                        placeholder="請輸入身分證字號"
                                        v-model="filter.identityNo"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :xl="4">
                            <el-form-item label="班級">
                                <el-input
                                        placeholder="請輸入班級"
                                        v-model="filter.className"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :xl="2">
                            <el-form-item label="模糊搜尋?">
                                <el-checkbox v-model="filter.fuzzy"></el-checkbox>
                            </el-form-item>
                        </el-col>
                        <el-col :xl="4">
                            <el-form-item label="關聯運算模式">
                                <el-radio-group v-model="filter.mode">
                                    <el-radio label="and">AND</el-radio>
                                    <el-radio label="or">OR</el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </el-col>
                        <el-col style="margin-bottom: 5px;">
                            <el-button
                                    @click="query"
                                    style="width: 100%"
                                    type="success"
                                    icon="el-icon-search"
                            >
                                查詢
                            </el-button>
                        </el-col>
                        <el-col>

                            <el-button
                                    @click="reset"
                                    style="width: 100%"
                                    icon="el-icon-refresh-left"
                            >
                                重設
                            </el-button>
                        </el-col>
                    </el-row>
                </el-form>
            </el-card>
        </el-collapse-transition>
        <el-table
                :data="pagedData"
                :default-sort="{prop:'student'}"
                border
                empty-text="查無資料"
                height="620px"
                stripe
        >
            <el-table-column
                    label="學號"
                    prop="studentId"
                    sortable
            ></el-table-column>
            <el-table-column
                    label="姓名"
                    prop="studentName"
                    sortable
            ></el-table-column>
            <el-table-column
                    label="身分證字號"
                    prop="identityNo"
                    sortable
            ></el-table-column>
            <el-table-column
                    label="出生年月日"
                    prop="birthdate"
                    sortable
            ></el-table-column>
            <el-table-column
                    label="班級"
                    prop="className"
                    sortable
            ></el-table-column>
            <el-table-column
                    label="手機"
                    prop="mobile"
                    sortable
            >
                <template #default="{row}">
                    <a :href="`tel:${row.mobileTelRef}`" :title="row.mobile">
                        {{row.mobile}}
                    </a>
                </template>
            </el-table-column>
            <el-table-column
                    label="緊急連絡人"
                    prop="guardianName"
                    sortable
            ></el-table-column>
            <el-table-column
                    label="緊急連絡人電話"
                    prop="guardianContact"
                    sortable
            >
                <template #default="{row}">
                    <a :href="`tel:${row.guardianContactTelRef}`" :title="row.guardianContact">
                        {{row.guardianContact}}
                    </a>
                </template>
            </el-table-column>
            <el-table-column
                    label="緊急連絡人手機"
                    prop="guardianMobile"
                    sortable
            >
                <template #default="{row}">
                    <a :href="`tel:${row.guardianMobileTelRef}`" :title="row.guardianMobile">
                        {{row.guardianMobile}}
                    </a>
                </template>
            </el-table-column>
            <el-table-column
                    label="緊急連絡人地址"
                    prop="guardianAddress"
                    sortable
            ></el-table-column>
            <el-table-column
                    label="導師"
                    prop="advisor"
                    sortable
            ></el-table-column>
            <el-table-column
                    label="導師電話"
                    prop="advisorContact"
                    sortable
            >
                <template #default="{row}">
                    <a :href="`tel:${row.advisorContactTelRef}`" :title="row.advisorContact">
                        {{row.advisorContact}}
                    </a>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination
                :page-size="pageSize"
                :total="students.length"
                @current-change="page => pageChange(page, students)"
                background
                layout="total, prev, pager, next"
                style="margin-top: 10px;"
                :current-page.sync="currentPage"
        ></el-pagination>
    </Sheet>
</template>

<script>
    import {mapActions, mapState, mapMutations} from 'vuex';
    import PagingMixin from '../pagingMixin';

    const defaultFilter = {
        studentId: '',
        className: '',
        studentName: '',
        identityNo: '',
        fuzzy: false,
        mode: 'and'
    };
    export default {
        name: 'QueryComponent',
        mixins: [PagingMixin],
        data: () => ({
            filter: {
                studentId: '',
                className: '',
                studentName: '',
                identityNo: '',
                fuzzy: false,
                mode: 'and'
            },
            showFilter: true
        }),
        computed: {
            ...mapState('student', ['students']),
            ...mapState(['loading']),
            ...mapState('school', ['schoolInfo']),
            schoolYear() {
                return (this.schoolInfo || {schoolYear: ''}).schoolYear;
            },
            semester() {
                return (this.schoolInfo || {semester: 0}).semester;
            }
        },
        methods: {
            ...mapActions('student', {
                getStudentsWithFilter: 'getStudentsWithFilterAction'
            }),
            ...mapMutations('student', ['saveStudents']),
            buildConditions() {
                const {studentId, className, studentName, identityNo} = this.filter;
                let cond = {};
                if (studentId) {
                    cond = {...cond, ['studentId']: studentId}
                }
                if (className) {
                    cond = {...cond, ['className']: className}
                }
                if (studentName) {
                    cond = {...cond, ['studentName']: studentName}
                }
                if (identityNo) {
                    cond = {...cond, ['identityNo']: identityNo}
                }

                return cond;
            },
            async query() {
                const {schoolYear, semester} = this;
                const {fuzzy, mode} = this.filter;
                const conditions = this.buildConditions();
                if (Object.keys(conditions).length === 0) {
                    this.$message({
                        message: '請至少選擇一項條件',
                        type: 'warning'
                    });
                    return;
                }

                await this.getStudentsWithFilter({
                    conditions,
                    schoolYear, semester, fuzzy, mode, all: true
                });
            },
            reset() {
                this.filter = {...defaultFilter};
                this.saveStudents([]);
            }
        },
        watch: {
            students(current) {
                this.pagedData = this.pageData(current, 1);
                this.currentPage = 1;
            }
        }
    }
</script>

<style>

</style>